import React from 'react';

import { styled } from '@mui/material/styles';
import ReactCodeInput from 'react-verification-code-input';
import styles from './styles';

const CodeInputRaw = (props) => (
  <ReactCodeInput
    {...props}
  />
);

const CodeInput = styled(CodeInputRaw)`${styles}`;

export default CodeInput;
